'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

const get = require('lodash.get');
const isEmpty = require('lodash.isempty');

const GalleryPhotoItemTag = require('./GalleryPhotoItemTag');

const styles = require('./GalleryPhotoItemTags.scss');
const help = require('../helpers/itemTagHelpers.es');

class GalleryPhotoItemTags extends React.Component {
    /**
     * EventHandlers on the wrapping component
     * @returns {object}
     */
    eventHandlers() {
        return {
            onClick: e => {
                if (this.props.itemTagsState.activeItemTag) {
                    e.stopPropagation();
                }
            },
            onMouseOver: () => {
                if (!this.props.itemTagsState.showItemTags) {
                    this.props.showItemTagIndicators();
                }
            },
            onMouseLeave: () => {
                this.props.hideItemTagIndicators();
            },
        };
    }

    /**
     * Props passed to GalleryPhotoItemTag for the given itemTag
     * @returns {object}
     */
    itemTagProps(itemTag) {
        const { showItemTags, activeItemTag } = this.props.itemTagsState;
        const { showItemTagTooltip, hideItemTagTooltip, trackLinkClick } = this.props;

        const creatorId = help.getCreatorId(itemTag);
        const creator = get(this.props, `creatorsMap[${creatorId}].displayName`);

        const categoryKey = help.getCategoryKey(itemTag);
        const category = get(this.props, `categoriesMap[${categoryKey}].name`);

        const similarItemsUrls = this.props.similarItemsUrls;
        const similarItemsUrl = get(this.props, `similarItemsUrls[${itemTag.id}]`);

        // active tag = currently focused tag
        const isActiveTag = showItemTags && itemTag.id === activeItemTag;

        // only show tooltip if active and all info loaded
        const tooltipVisible = isActiveTag && !isEmpty(category) && similarItemsUrls !== void 0;

        return {
            // state
            key: itemTag.id,
            isActiveTag,
            tooltipVisible,

            // tag data
            id: itemTag.id,
            name: itemTag.name,
            point: itemTag.coordinate.point,
            creator: creatorId && !isEmpty(creator) ? creator : null,
            category,
            similarItemsUrl,

            // actions
            showItemTagTooltip,
            hideItemTagTooltip,
            trackLinkClick,
        };
    }

    render() {
        const { itemTags, imageDimensions } = this.props;
        const { showItemTags, activeItemTag } = this.props.itemTagsState;

        const className = classNames(styles.wrapper, {
            [styles.showItemTags]: showItemTags && !activeItemTag,
            [styles.showActiveTag]: !!activeItemTag,
        });

        return (
            <div className={className} style={imageDimensions} {...this.eventHandlers()}>
                {/* Render Item Tags */}
                {itemTags.map(itemTag => <GalleryPhotoItemTag {...this.itemTagProps(itemTag)} />)}
            </div>
        );
    }
}

GalleryPhotoItemTags.propTypes = {
    itemTags: PropTypes.array.isRequired,
    similarItemsUrls: PropTypes.object,

    itemTagsState: PropTypes.shape({
        activeItemTag: PropTypes.number,
        showItemTags: PropTypes.bool.isRequired,
    }).isRequired,
    imageDimensions: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
    }).isRequired,
    creatorsMap: PropTypes.object.isRequired,
    categoriesMap: PropTypes.object.isRequired,

    // Actions
    showItemTagIndicators: PropTypes.func.isRequired,
    hideItemTagIndicators: PropTypes.func.isRequired,
    showItemTagTooltip: PropTypes.func.isRequired,
    hideItemTagTooltip: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
};

module.exports = GalleryPhotoItemTags;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/GalleryPhotoItemTags.jsx